import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export const SearchIcon = () => {
  return (
    <svg
      data-testid={applyDataTestId(pom.header.searchIcon)}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <title>Search</title>
      <path
        d="M12.0017 12.0016L16.9994 17M13.3761 4.92513C14.7681 8.20047 13.2413 11.9841 9.96596 13.3761C6.69062 14.7681 2.907 13.2413 1.51502 9.96596C0.123032 6.69062 1.64979 2.907 4.92513 1.51502C8.20047 0.123032 11.9841 1.64979 13.3761 4.92513Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
